export default "__VITE_ASSET__CMTALh4y__"